import { render, staticRenderFns } from "./Pediatria.vue?vue&type=template&id=7ee7a324"
import script from "./Pediatria.vue?vue&type=script&lang=js"
export * from "./Pediatria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports